import {RouterModule, Routes} from '@angular/router';

import {CustomerComponent} from './customer.component';
import {ListComponent} from './list/list.component';
import {EditComponent} from './edit/edit.component';

// noinspection TypeScriptValidateTypes
const routes: Routes = [
    {
        path: '',
        component: CustomerComponent,
        children: [
            {path: '', redirectTo: 'list', pathMatch: 'full'},
            {path: 'list', component: ListComponent},
            {path: 'edit/:id', component: EditComponent},
        ]
    }
];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/customer/customer.routing.ts